var exports = {
  "N1": "headerContainer__PyEART",
  "VW": "headerContent__3QkdHr",
  "R_": "heading__JDpkxh",
  "h_": "description__SeoM3v",
};

module.exports = exports;
